import { IPromise } from 'angular'
import { ApiResponse, ApiSale } from '@vend/types'
import { VdFeatureManager } from '@vend/vend.js'

import { extractData } from '../../../util/extract-data'
import { $http } from '../../../ng-compat/imports'

interface SearchOptions {
  status?: string
  outlet_id?: string
  order_by?: string
  order_direction?: string
}

/**
 * Resource for querying the search API.
 *
 * @deprecated This was only used by retrieve sales and is not needed for the React version
 */
export class SearchResource {
  constructor(private readonly vdFeatureManager: VdFeatureManager) {
    'ngInject'
    this.vdFeatureManager = vdFeatureManager
  }

  /**
   * Search for sales matching the given criteria.
   *
   * @param  options
   *         Additional options and criteria to influence the results.
   *
   *         @param options.status
   *                Limit the results to sales with this status
   *
   *         @param options.outlet_id
   *                Limit the results to sales made in the outlet with this ID
   *
   *         @param options.order_by
   *                Order the results by the given field, defaults to 'date'
   *
   *         @param options.order_direction
   *                The sort direction of the results, defaults to 'desc'
   *
   * @return A promise resolved with the array of sales matching the given options
   */
  public sales(options: SearchOptions): IPromise<ApiSale[]> {
    const useReadApi = this.vdFeatureManager.get('parked_sales_from_read_api')

    if (useReadApi) {
      const SEARCH_ENDPOINT = '/api/2.0/sales'
      const config = {
        params: {
          desc: 1,
          ...options,
        },
      }
      return $http
        .get<ApiResponse<ApiSale[]>>(SEARCH_ENDPOINT, config)
        .then(extractData)
    } else {
      const SEARCH_ENDPOINT = '/api/2.0/search'
      const defaults = { order_by: 'date', order_direction: 'desc' }
      const config = {
        params: {
          ...defaults,
          ...options,
          type: 'sales',
        },
      }

      return $http
        .get<ApiResponse<ApiSale[]>>(SEARCH_ENDPOINT, config)
        .then(extractData)
    }
  }
}
